import { render, staticRenderFns } from "./Testings.vue?vue&type=template&id=1b2f4e0e"
import script from "./Testings.vue?vue&type=script&lang=ts"
export * from "./Testings.vue?vue&type=script&lang=ts"
import style0 from "./Testings.vue?vue&type=style&index=0&id=1b2f4e0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports